module.exports = __webpack_public_path__ + "7faf82cf324a4c793e8bd1f9c2e6df92.MP3";